export * as dialogsApi from './endpoints';
export { messagesAdapter, messagesSelector } from './lib';
export type { SendMessageApiRequest } from './types';
